import { RepareoLogo } from "@App/Components/atoms/whitelabel/logos/RepareoLogo";
import { SixtLogo } from "@App/Components/atoms/whitelabel/logos/SixtLogo";
import type { Config } from "@App/configs/interfaces";

/**
 * Configuration for the Sixt whitelabel.
 * Extends the default configuration with specific settings for Sixt.
 */
export const config: Partial<Config> = {
  slug: "sixt",
  navbar: {
    logos: {
      right: {
        component: <SixtLogo />,
      },
      left: {
        component: <RepareoLogo />,
      },
    },
    backToPartnerButton: {
      url: "https://www.mahle.com/de/",
    },
  },
  reviews: {
    show: true,
  },
};

export default config;
